import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Divider } from '@startengine/design-system.ui.divider';
import PropTypes from 'prop-types';
import React from 'react';

export const FinancialsDropDown = ({ rows = [] }) => {
  if (rows?.some((row) => row?.display === true)) {
    return (
      <Grid container spacing={1}>
        <Grid item xs={4} />
        <Grid item xs={4}>
          <Typography
            variant="p1"
            sx={{
              maxWidth: '120px',
            }}
          >
            Most Recent Fiscal Year-End
          </Typography>
        </Grid>
        <Grid item xs={4} mb={1}>
          <Typography
            variant="p1"
            sx={{
              maxWidth: '90px',
            }}
          >
            Prior Fiscal Year-End
          </Typography>
        </Grid>
        {rows?.map((row, index) => {
          if (row?.id !== null && row?.display) {
            return (
              <React.Fragment key={row?.id}>
                <Grid item xs={4}>
                  <Typography variant="p1" color="success">
                    {row?.label}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="p1Medium">{row?.mostRecent}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="p1Medium">{row?.prior}</Typography>
                </Grid>
                {rows?.length > index + 1 && index !== rows.length - 1 && (
                  <Grid item xs={12} mb={1}>
                    <Divider />
                  </Grid>
                )}
              </React.Fragment>
            );
          }

          return null;
        })}
      </Grid>
    );
  }

  return null;
};

FinancialsDropDown.propTypes = {
  rows: PropTypes.array,
};
